/* Generated File DO NOT EDIT. */
/* tslint:disable */
import * as Types from '../graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetActivitiesQueryVariables = Types.Exact<{
  offset: Types.Scalars['Int'];
}>;

export type GetActivitiesQuery = {
  __typename?: 'Query';
  activities: Array<{
    __typename?: 'Activity';
    _id: string;
    description: string;
    domainID: string;
    type: Types.ActivityType;
    subgoal?: string | null;
    schedule: Array<{ __typename?: 'DayAndPeriod'; day: string; period: Array<string> }>;
  }>;
};

export type GetPreviousActivitiesQueryVariables = Types.Exact<{
  offset: Types.Scalars['Int'];
}>;

export type GetPreviousActivitiesQuery = {
  __typename?: 'Query';
  previousActivities: Array<{
    __typename?: 'Activity';
    _id: string;
    description: string;
    domainID: string;
    type: Types.ActivityType;
    subgoal?: string | null;
    schedule: Array<{ __typename?: 'DayAndPeriod'; day: string; period: Array<string> }>;
  }>;
  activities: Array<{ __typename?: 'Activity'; _id: string; description: string; domainID: string; type: Types.ActivityType }>;
};

export type GetActivityQueryVariables = Types.Exact<{
  id: Types.Scalars['String'];
}>;

export type GetActivityQuery = {
  __typename?: 'Query';
  activity: {
    __typename?: 'Activity';
    _id: string;
    description: string;
    domainID: string;
    type: Types.ActivityType;
    subgoal?: string | null;
    schedule: Array<{ __typename?: 'DayAndPeriod'; day: string; period: Array<string> }>;
    domain: { __typename?: 'Domain'; _id: string; title: string; color?: string | null; iconUrl?: string | null };
  };
};

export type CreateActivityMutationVariables = Types.Exact<{
  input: Types.ActivityInput;
}>;

export type CreateActivityMutation = {
  __typename?: 'Mutation';
  createActivity: {
    __typename?: 'Activity';
    _id: string;
    description: string;
    userId: string;
    domainID: string;
    type: Types.ActivityType;
    subgoal?: string | null;
    schedule: Array<{ __typename?: 'DayAndPeriod'; day: string; period: Array<string> }>;
  };
};

export type UpdateActivityMutationVariables = Types.Exact<{
  id: Types.Scalars['String'];
  input: Types.ActivityInput;
}>;

export type UpdateActivityMutation = {
  __typename?: 'Mutation';
  updateActivity: {
    __typename?: 'Activity';
    _id: string;
    description: string;
    userId: string;
    domainID: string;
    type: Types.ActivityType;
    subgoal?: string | null;
    schedule: Array<{ __typename?: 'DayAndPeriod'; day: string; period: Array<string> }>;
  };
};

export type UpdateActivityStatusMutationVariables = Types.Exact<{
  input: Types.ActivityLogInput;
}>;

export type UpdateActivityStatusMutation = { __typename?: 'Mutation'; updateActivityStatus: boolean };

export type NeedToScheduleAChallengingActivityQueryVariables = Types.Exact<{
  offset: Types.Scalars['Int'];
}>;

export type NeedToScheduleAChallengingActivityQuery = { __typename?: 'Query'; needToScheduleAChallengingActivity: boolean };

export const GetActivitiesDocument = gql`
  query GetActivities($offset: Int!) {
    activities(offset: $offset) {
      _id
      description
      domainID
      type
      schedule {
        day
        period
      }
      subgoal
    }
  }
`;

/**
 * __useGetActivitiesQuery__
 *
 * To run a query within a React component, call `useGetActivitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActivitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActivitiesQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetActivitiesQuery(baseOptions: Apollo.QueryHookOptions<GetActivitiesQuery, GetActivitiesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetActivitiesQuery, GetActivitiesQueryVariables>(GetActivitiesDocument, options);
}
export function useGetActivitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetActivitiesQuery, GetActivitiesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetActivitiesQuery, GetActivitiesQueryVariables>(GetActivitiesDocument, options);
}
export type GetActivitiesQueryHookResult = ReturnType<typeof useGetActivitiesQuery>;
export type GetActivitiesLazyQueryHookResult = ReturnType<typeof useGetActivitiesLazyQuery>;
export type GetActivitiesQueryResult = Apollo.QueryResult<GetActivitiesQuery, GetActivitiesQueryVariables>;
export const GetPreviousActivitiesDocument = gql`
  query GetPreviousActivities($offset: Int!) {
    previousActivities(offset: $offset) {
      _id
      description
      domainID
      type
      schedule {
        day
        period
      }
      subgoal
    }
    activities(offset: $offset, includeFuture: true) {
      _id
      description
      domainID
      type
    }
  }
`;

/**
 * __useGetPreviousActivitiesQuery__
 *
 * To run a query within a React component, call `useGetPreviousActivitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPreviousActivitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPreviousActivitiesQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetPreviousActivitiesQuery(baseOptions: Apollo.QueryHookOptions<GetPreviousActivitiesQuery, GetPreviousActivitiesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetPreviousActivitiesQuery, GetPreviousActivitiesQueryVariables>(GetPreviousActivitiesDocument, options);
}
export function useGetPreviousActivitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPreviousActivitiesQuery, GetPreviousActivitiesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetPreviousActivitiesQuery, GetPreviousActivitiesQueryVariables>(GetPreviousActivitiesDocument, options);
}
export type GetPreviousActivitiesQueryHookResult = ReturnType<typeof useGetPreviousActivitiesQuery>;
export type GetPreviousActivitiesLazyQueryHookResult = ReturnType<typeof useGetPreviousActivitiesLazyQuery>;
export type GetPreviousActivitiesQueryResult = Apollo.QueryResult<GetPreviousActivitiesQuery, GetPreviousActivitiesQueryVariables>;
export const GetActivityDocument = gql`
  query GetActivity($id: String!) {
    activity(id: $id) {
      _id
      description
      domainID
      type
      schedule {
        day
        period
      }
      subgoal
      domain {
        _id
        title
        color
        iconUrl
      }
    }
  }
`;

/**
 * __useGetActivityQuery__
 *
 * To run a query within a React component, call `useGetActivityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActivityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActivityQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetActivityQuery(baseOptions: Apollo.QueryHookOptions<GetActivityQuery, GetActivityQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetActivityQuery, GetActivityQueryVariables>(GetActivityDocument, options);
}
export function useGetActivityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetActivityQuery, GetActivityQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetActivityQuery, GetActivityQueryVariables>(GetActivityDocument, options);
}
export type GetActivityQueryHookResult = ReturnType<typeof useGetActivityQuery>;
export type GetActivityLazyQueryHookResult = ReturnType<typeof useGetActivityLazyQuery>;
export type GetActivityQueryResult = Apollo.QueryResult<GetActivityQuery, GetActivityQueryVariables>;
export const CreateActivityDocument = gql`
  mutation CreateActivity($input: ActivityInput!) {
    createActivity(input: $input) {
      _id
      description
      userId
      domainID
      type
      schedule {
        day
        period
      }
      subgoal
    }
  }
`;
export type CreateActivityMutationFn = Apollo.MutationFunction<CreateActivityMutation, CreateActivityMutationVariables>;

/**
 * __useCreateActivityMutation__
 *
 * To run a mutation, you first call `useCreateActivityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateActivityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createActivityMutation, { data, loading, error }] = useCreateActivityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateActivityMutation(baseOptions?: Apollo.MutationHookOptions<CreateActivityMutation, CreateActivityMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateActivityMutation, CreateActivityMutationVariables>(CreateActivityDocument, options);
}
export type CreateActivityMutationHookResult = ReturnType<typeof useCreateActivityMutation>;
export type CreateActivityMutationResult = Apollo.MutationResult<CreateActivityMutation>;
export type CreateActivityMutationOptions = Apollo.BaseMutationOptions<CreateActivityMutation, CreateActivityMutationVariables>;
export const UpdateActivityDocument = gql`
  mutation UpdateActivity($id: String!, $input: ActivityInput!) {
    updateActivity(id: $id, input: $input) {
      _id
      description
      userId
      domainID
      type
      schedule {
        day
        period
      }
      subgoal
    }
  }
`;
export type UpdateActivityMutationFn = Apollo.MutationFunction<UpdateActivityMutation, UpdateActivityMutationVariables>;

/**
 * __useUpdateActivityMutation__
 *
 * To run a mutation, you first call `useUpdateActivityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateActivityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateActivityMutation, { data, loading, error }] = useUpdateActivityMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateActivityMutation(baseOptions?: Apollo.MutationHookOptions<UpdateActivityMutation, UpdateActivityMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateActivityMutation, UpdateActivityMutationVariables>(UpdateActivityDocument, options);
}
export type UpdateActivityMutationHookResult = ReturnType<typeof useUpdateActivityMutation>;
export type UpdateActivityMutationResult = Apollo.MutationResult<UpdateActivityMutation>;
export type UpdateActivityMutationOptions = Apollo.BaseMutationOptions<UpdateActivityMutation, UpdateActivityMutationVariables>;
export const UpdateActivityStatusDocument = gql`
  mutation updateActivityStatus($input: ActivityLogInput!) {
    updateActivityStatus(input: $input)
  }
`;
export type UpdateActivityStatusMutationFn = Apollo.MutationFunction<UpdateActivityStatusMutation, UpdateActivityStatusMutationVariables>;

/**
 * __useUpdateActivityStatusMutation__
 *
 * To run a mutation, you first call `useUpdateActivityStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateActivityStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateActivityStatusMutation, { data, loading, error }] = useUpdateActivityStatusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateActivityStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateActivityStatusMutation, UpdateActivityStatusMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateActivityStatusMutation, UpdateActivityStatusMutationVariables>(UpdateActivityStatusDocument, options);
}
export type UpdateActivityStatusMutationHookResult = ReturnType<typeof useUpdateActivityStatusMutation>;
export type UpdateActivityStatusMutationResult = Apollo.MutationResult<UpdateActivityStatusMutation>;
export type UpdateActivityStatusMutationOptions = Apollo.BaseMutationOptions<UpdateActivityStatusMutation, UpdateActivityStatusMutationVariables>;
export const NeedToScheduleAChallengingActivityDocument = gql`
  query needToScheduleAChallengingActivity($offset: Int!) {
    needToScheduleAChallengingActivity(offset: $offset)
  }
`;

/**
 * __useNeedToScheduleAChallengingActivityQuery__
 *
 * To run a query within a React component, call `useNeedToScheduleAChallengingActivityQuery` and pass it any options that fit your needs.
 * When your component renders, `useNeedToScheduleAChallengingActivityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNeedToScheduleAChallengingActivityQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useNeedToScheduleAChallengingActivityQuery(
  baseOptions: Apollo.QueryHookOptions<NeedToScheduleAChallengingActivityQuery, NeedToScheduleAChallengingActivityQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<NeedToScheduleAChallengingActivityQuery, NeedToScheduleAChallengingActivityQueryVariables>(NeedToScheduleAChallengingActivityDocument, options);
}
export function useNeedToScheduleAChallengingActivityLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<NeedToScheduleAChallengingActivityQuery, NeedToScheduleAChallengingActivityQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<NeedToScheduleAChallengingActivityQuery, NeedToScheduleAChallengingActivityQueryVariables>(NeedToScheduleAChallengingActivityDocument, options);
}
export type NeedToScheduleAChallengingActivityQueryHookResult = ReturnType<typeof useNeedToScheduleAChallengingActivityQuery>;
export type NeedToScheduleAChallengingActivityLazyQueryHookResult = ReturnType<typeof useNeedToScheduleAChallengingActivityLazyQuery>;
export type NeedToScheduleAChallengingActivityQueryResult = Apollo.QueryResult<NeedToScheduleAChallengingActivityQuery, NeedToScheduleAChallengingActivityQueryVariables>;
